const receiptManage = () => import('@/components/platform/receipt/receiptManage') //收款管理
const withdrawalPayment = () => import('@/components/platform/withdrawal/withdrawalPayment') //提现打款
// 审核管理
const withdrawalCollection = () => import('@/components/platform/withdrawal/withdrawalCollection') //提现审核
const payAudit = () => import('@/components/finance/audit/pay/payAudit') //充值审核
// 渠道结算   
const commission = () => import('@/components/finance/close/brokerage/index')
const orderClose = () => import('@/components/finance/close/order/index')
// 月结明细表
const monthlyBalanceList = () => import('@/components/finance/monthlyBalanceList/index')
export default [{
    path: "/receiptManage",
    meta: {
      belong: ['finance'],
      text: '收款管理',
    },
    name: 'receiptManage',
    component: receiptManage
  },
  {
    path: "/withdrawalPayment",
    meta: {
      belong: ['finance'],
      text: '提现打款',
    },
    name: 'withdrawalPayment',
    component: withdrawalPayment
  },
  {
    path: "/withdrawalCollection",
    meta: {
      belong: ['finance'],
      text: '提现审核',
    },
    name: 'withdrawalCollection',
    component: withdrawalCollection
  },
  {
    path: "/payAudit",
    meta: {
      belong: ['finance'],
      text: '充值审核',
    },
    name: 'payAudit',
    component: payAudit
  },
  {
    path: "/orderClose",
    meta: {
      belong: ['finance'],
      text: '订单结算',
    },
    name: 'orderClose',
    component: orderClose
  },
  {
    path: "/commission",
    meta: {
      belong: ['finance'],
      text: '佣金结算',
    },
    name: 'commission',
    component: commission
  },
  {
    path: "/monthlyBalanceList",
    meta: {
      belong: ['finance'],
      text: '月结明细表',
    },
    name: 'monthlyBalanceList',
    component: monthlyBalanceList
  },
]
